import styled from "styled-components";
import zIndexTypes from "../../../theme/zIndexTypes";
import {
  mediaMinWidth,
  mediaMaxWidth,
  mediaMaxHeight,
} from "../../utils/mediaQueriesTemplate";

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${zIndexTypes.modal};
  display: flex;
  justify-content: center;
  align-items: center;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.fadeIn {
    animation-name: fadeIn;
  }

  &.animated {
    animation-duration: 0.4s;
    animation-fill-mode: both;
  }

  ${mediaMaxHeight.phone`
    align-items: unset;
  `}

  ${mediaMaxWidth.tablet`
    align-items: unset;
  `}
`;

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 800px;
  height: ${(props) => (props.iOS ? "470px" : "520px")};
  height: ${(props) =>
    props.cardUpdateNewColumn === "rejected-candidates" && "480px"};
  z-index: ${zIndexTypes.modal};
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.smallDesktop`
    margin-left: unset;
    width: calc(100vw - 30px);
  `}

  ${mediaMaxWidth.tablet`
    top: 10px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 20px);
    padding: 10px 10px;
  `}

  ${mediaMaxHeight.phone`
    top: 10px;
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;

  ${mediaMaxWidth.phone`
    padding: 5px;
    font-size: 0.9em;
  `}
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop`
    width: 95%;
  `}
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;
